<template>
  <div class="chart" ref="chartdiv" style="height: 300px;">
  </div>
</template>
<style itemscope>
  .chart{
    width: 100%;
    height: 500px;
  }
</style>
<script>
  import moment from 'moment';
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4themes_animated from "@amcharts/amcharts4/themes/animated";

  am4core.useTheme(am4themes_animated);

  export default {
    name: 'LineChart',
    props : {
      data : {
        type : Array,
        required : false
      },
      label :{
        type: String,
        required: true
      },
      color :{
        type: String,
        required: false
      }
    },
    data(){
      return {
        chart : null
      }
    },
    watch : {
      data(newVal, oldVal){
        if(this.chart){
          this.chart.data = newVal;
        }
      }
    },
    mounted() {

      am4core.useTheme(am4themes_animated);

      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      chart.responsive.enabled = true;

    // Add data
      chart.data = this.data;


// Create axes
      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.minGridDistance = 50;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

// Create series
      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = this.label;
      series.dataFields.dateX = "date";
      series.strokeWidth = 2;
      series.minBulletDistance = 10;
      series.tooltipText = "{valueY}";
      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 20;
      series.tooltip.background.fillOpacity = 0.5;
      series.tooltip.label.padding(12,12,12,12)
      series.stroke = am4core.color(this.color ? this.color : "rgb(115, 103, 240)");


// Add cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      chart.cursor.snapToSeries = series;

      this.chart = chart;
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }
    }
  }
</script>
